import { supabase } from '../supabase';
import { Role, User } from '../utils/types';

export const fetchUserProfile = async (userId: string) => {
  if (!userId) {
    console.error('No user ID provided to fetchUserProfile');
    return null;
  }
  try {
    const { data: userData, error: userError } = await supabase
      .from('User')
      .select('*')
      .eq('auth_id', userId)
      .single();

    if (userError) throw userError;
    return userData;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw new Error('Failed to fetch user profile');
  }
};

export const fetchUsers = async () => {
  try {
    const { data: users, error: usersError } = await supabase.from('User').select('*');
    console.log(users);
    if (usersError) throw usersError;
    return users;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to fetch users');
  }
};

export const updateUser = async (user: User) => {
  try {
    const { data: userData, error: userError } = await supabase
      .from('User')
      .update(user)
      .eq('auth_id', user.auth_id)
      .select();
    if (userError) return null;
    return userData;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to update user');
  }
};

type CreateUserPayload = {
  first_name: string;
  last_name: string;
  password: string;
  email: string;
  phone_number: string;
  role: Role[];
  auth_id?: string;
};

export const createUser = async (user: CreateUserPayload) => {
  try {
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email: user.email,
      password: user.password,
    });

    if (authError) throw authError;
    user.auth_id = authData.user?.id;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { password, ...dataForUser } = {
      ...user,
      auth_id: authData.user?.id,
    };

    const { data: userData, error: userError } = await supabase
      .from('User')
      .insert(dataForUser)
      .select();

    if (userError) return null;
    return userData;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to create user');
  }
};

export const deleteUser = async (auth_id: string) => {
  try {
    // Delete from User table
    const { data: userData, error: userError } = await supabase
      .from('User')
      .delete()
      .eq('auth_id', auth_id)
      .select();

    if (userError) throw userError;

    // Delete from auth
    // const { error: authError } = await supabase.auth.admin.deleteUser(auth_id);

    // if (authError) throw authError;

    return userData;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to delete user');
  }
};
